import { HttpInterceptorFn } from '@angular/common/http';

export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
  console.log('HTTP Request:', {
    url: req.url,
    method: req.method,
    headers: {
      authorization: req.headers.get('Authorization'),
      contentType: req.headers.get('Content-Type')
    }
  });
  
  return next(req);
};
